import { render } from "./InventoryDetailsReport.vue?vue&type=template&id=09cca463&scoped=true"
import script from "./InventoryDetailsReport.vue?vue&type=script&lang=js"
export * from "./InventoryDetailsReport.vue?vue&type=script&lang=js"

import "./InventoryDetailsReport.vue?vue&type=style&index=0&id=09cca463&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cca463"]])

export default __exports__